import React, { type FC } from 'react';

interface DiscountBadgeProps {
  text: string;
  percent: number;
}

const DiscountBadge: FC<DiscountBadgeProps> = ({ text, percent }) => {
  return (
    <div className="inline-block rounded-lg bg-black-500 px-2 py-1 text-white">
      <span className="text-[12px] font-bold">{percent}% </span>
      <span className="text-[12px]">{text}</span>
    </div>
  );
};

export default DiscountBadge;
